import React, { Component } from "react";
import { connect } from "react-redux";
import { axiosUserManagement } from "../../axios";
import { Helmet } from "react-helmet";
import DeleteAccount from "../../components/forms/DeleteAccount";
import { getParameterByName } from "../../util/commonFunctions";
import { logout } from "../../actions";
import { handleActionError } from "../../util/error";

class DeleteAccountComponent extends Component {
  state = {
    loader: true,
    message: null,
    errorMessage: null
  };

  componentDidMount() {
    const verifyToken = decodeURIComponent(window.location.search);
    let config = {
      headers: {
        "cache-control": "no-cache",
        "content-type": "application/json",
        token:
          getParameterByName("token", verifyToken) &&
          getParameterByName("token", verifyToken).length > 0
            ? getParameterByName("token", verifyToken)
            : ""
      }
    };

    axiosUserManagement
      .delete("/subscriber", {
        ...config
      })
      .then(res => {
        this.props.onLogout();
        this.setState({
          loader: false,
          errorMessage: null,
          message: res.data.message
        });
      })
      .catch(err => {
        handleActionError("An error occurred deleting a subscriber", err);
        this.setState({
          loader: false,
          errorMessage: err.response.data.message,
          message: null
        });
      });
  }

  render() {
    return (
      <React.Fragment>
        <Helmet title="Delete" />
        <div className="background">
          <div className="container">
            <div className="row">
              <div className="col-12 no-gutter-col">
                <div className="signInUpFlow">
                  <DeleteAccount
                    message={this.state.message}
                    errorMessage={this.state.errorMessage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onLogout: () => dispatch(logout())
  };
};

export default {
  component: connect(null, mapDispatchToProps)(DeleteAccountComponent)
};
